import React, { createContext, useState, useEffect } from 'react';

export const ThemeContext = createContext(null);

export const ThemeProvider = ({ children }) => {
    const [theme, setTheme] = useState(() => {
        return localStorage.getItem('rutex_theme_mode') || 'light';
    });

    useEffect(() => {
        const root = document.documentElement;
        const body = document.body;

        if (theme === 'dark') {
            body.classList.add('dark-theme');
            root.setAttribute('data-theme', 'dark');
            localStorage.setItem('rutex_theme_mode', 'dark');
        } else {
            body.classList.remove('dark-theme');
            root.setAttribute('data-theme', 'light');
            localStorage.setItem('rutex_theme_mode', 'light');
        }
    }, [theme]);

    const toggleTheme = () => {
        setTheme(prev => (prev === 'light' ? 'dark' : 'light'));
    };

    return (
        <ThemeContext.Provider value={{ theme, isDark: theme === 'dark', toggleTheme, setTheme }}>
            {children}
        </ThemeContext.Provider>
    );
};
